import { Component, computed, inject, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BottomSheetConfig, BottomSheetData } from 'src/app/interfaces/mat.interface';
import { MatBottomSheetService } from 'src/app/services/mat-bottom-sheet.service';
import { MakePaymentComponent } from '../../../planner/components/buy-tickets/components/make-payment/make-payment.component';
import { BreakpointsService } from 'src/app/services/breakpoints.service';

@Component({
  selector: 'app-make-payment-button',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './make-payment-button.component.html',
  styleUrls: ['./make-payment-button.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MakePaymentButtonComponent {
  private _matBottomSheetService = inject(MatBottomSheetService);
  private _breakpointsService = inject(BreakpointsService);
  
  private _isMobile = computed(() => this._breakpointsService.isMobile());
    
  async handleMakePaymentClick(): Promise<void> {
    await this._openMakePaymentBottomSheet();
  }

  private async _openMakePaymentBottomSheet(): Promise<void> {
    const bottomSheetConfig: BottomSheetConfig<MakePaymentComponent, BottomSheetData> = {
      component: MakePaymentComponent,
      panelClass: this._isMobile() ? 'make-payment-bottom-sheet--mobile' : 'make-payment-bottom-sheet--desktop',
    }    
    
    await this._matBottomSheetService.openMatBottomSheet(bottomSheetConfig);
  }
}
